<template lang="html">
  <section id="semantic-search" 
    class="semantic-search py-1" 
    :class="{'bg-white' : addWords, 'desktop' : !mobile, 'mobile' : mobile }" 
    v-hotkey.prevent="keymap">
    <div v-if="mobile">
      <div class="position-relative">
        <h3 class="m-0 d-inline" :class="{'text-primary' : addWords}">{{hebrew ? 'שדה סמנטי' : 'Semantic field'}}
            ({{hebrew ? 'בטא' : 'Beta'}})
        </h3>       
      </div>             
    </div>
    <div
      class="position-relative d-flex justify-content-between px-2"
      style="cursor:pointer"
      @click="addWords = !addWords"
      v-if="!mobile"
      > 
      <h3 class="m-0" :class="{'text-primary' : addWords}">{{hebrew ? 'שדה סמנטי' : 'Semantic field'}}
        ({{hebrew ? 'בטא' : 'Beta'}})
      </h3>
      <i v-if="addWords" class="fas fa-sort-up text-primary" style="margin-top:6px;"></i>
      <i v-if="!addWords" class="fas fa-sort-down" ></i>
    </div>
    <div class="semantic-wrap px-lg-2 mt-2 mb-md-0  position-relative" v-if="addWords || mobile">          
      <label v-if="!mobile" class="mb-1 mt-2" for="semantic-words">{{hebrew ? 'הזן מילים שמגדירות את המשמעות' : 'Choose semantic words'}}</label>
      <span v-if="!mobile" id="semantic-search-popover"><i class="fa fa-info-circle mr-1"></i></span>
      <b-popover target="semantic-search-popover" container="" placement="top" triggers="hover focus">
        {{hebrew ? 'כדי לצמצם את התוצאות לכאלו בעלות משמעות מסויימת, הזינו מילים עם משמעות קרובה' : 'xxx'}}
      </b-popover>
      <div ref="semanticInputWrap"
        :class="{'mb-4': !mobile}"
        @click="inputFocus"
        class="search-input-wrap position-relative border border-dark pt-1">
        <ul class="d-inline-block w-auto p-0 m-0" id="semantic-list">
          <li 
          :class="{'py-1': !mobile}"
          class="d-inline-block w-auto rounded px-2 mb-1 f-narkis mr-1" 
          v-for="item in semanticSelectedWords" :key="item">
          <span>{{ item }}</span>
          <span @click="removeSemanticWord(item)" class="pr-2 pl-1">
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
        </li>
        </ul>
        <div class="d-inline-block">
          <TypeAhead 
            @run-search="addSemanticKeyword"
            @input-focused="taFocused"
            @input-unfocused="taUnFocused"
            :typeAheadFunc="getSemanticTypeAheads"
            :forceHebrew = true
            :searchId = "'search-semantic-term'"
            :customClass = "'semantic-ta'"
            :clearAfterSet = "true"
          />
        </div>
      </div>
    </div>  
  </section>
</template>

<script lang="js">
  import {Actions} from '@/store/stateChanges'
  import TypeAhead from '@/components/TypeAhead'
  import axios from 'axios'
  import {StoreConfig} from '@/store/storeConfig'

  axios.defaults.headers = {
    'Content-Type': 'application/json'
  }
  const axiosInstance = axios.create({timeout: 130000})
  const TIP_SERVER = StoreConfig.TIP_SERVER

  export default  {
    name: 'SemanticSearch',
    components: {
      TypeAhead
    },
    data() {
      return {
        addWords: this.mobile,
        showPopover: false
      }
    },
    mounted () {
      if (document.getElementById('search-semantic-term')) {
        document.getElementById('search-semantic-term').size = document.getElementById('search-semantic-term').value.length+1
      }
    },
    methods: {
      inputFocus () {
        document.getElementById('search-semantic-term').focus()
      },
      hideTooltip () {
        if (this.showPopover) {
          this.showPopover = false
        } else {
          this.showPopover = true
        }
      },
      taFocused () {
        this.$refs.semanticInputWrap.classList.remove('border-dark')
        this.$refs.semanticInputWrap.classList.add('border-primary')
        document.getElementById('search-semantic-term').size = document.getElementById('search-semantic-term').value.length+1
      },
      taUnFocused() {
        this.$refs.semanticInputWrap.classList.remove('border-primary')
        this.$refs.semanticInputWrap.classList.add('border-dark')
      },
      getSemanticTypeAheads: async function (wordSoFar) {
        document.getElementById('search-semantic-term').size = wordSoFar.length+1
        const result = await axiosInstance.post(
          TIP_SERVER, JSON.stringify({
            w: wordSoFar,
            thresh: 30
          })
        )
        return result.data
      },  
      deleteTerm () {
        if (document.getElementById('search-semantic-term').value === '') {
          this.$store.commit('REMOVE_SEMANTIC_ITEM', this.semanticSelectedWords.length -1)
          this.$store.dispatch(Actions.RUN_CHARUZIT)
        }
      },     
      removeSemanticWord (remove) {
        var index = this.semanticSelectedWords.indexOf(remove); 
        this.$store.commit('REMOVE_SEMANTIC_ITEM',  index)       
        if (!this.mobile) {          
          this.$store.dispatch(Actions.RUN_CHARUZIT)
        } else {
          this.$emit('word-removed', {remove, index})
        }
      },      
      addSemanticKeyword (txt) {
        var index = this.semanticSelectedWords.indexOf(txt)
        if (index < 0) {
          this.$store.commit('SET_SEMANTICS',  txt)
          document.getElementById('search-semantic-term').size = 1
          if(!this.mobile) {                      
            this.$store.dispatch(Actions.RUN_CHARUZIT)            
            document.getElementById('search-semantic-term').focus()                              
          } else {
            this.$emit('word-selected', txt)           
          }
          this.$nextTick(function () { 
            document.getElementById('search-semantic-term').value = ""
          })               
        }
      }  
    },
    computed: {
      mobile () {
        return this.$mq === 'xs'
      },      
      keymap () {
        return {         
          'backspace': () => {
            if (document.activeElement.id === 'search-semantic-term') this.deleteTerm()
          }
        }
      },      
      hebrew () {
        return this.$settings.hebrew
      },
      tipRunning () {  
        return this.$store.state.tipApiState === 'Running'
      },       
      semanticSelectedWords: function() {
        return this.$store.state.semanticKeywordsArr
      }
    }  
  }
</script>

<style  lang="scss">
.semantic-search {
  &.desktop {
    border-top: 1px solid #c8c8c8;
    border-bottom:1px solid #c8c8c8;
  }  
  @media (max-width: 991px) {
    .fa-info-circle {
      font-size: 22px;
      position: relative;
      top: 3px;      
    }      
  }
  .semantic-ta {
    .typeahead-wrap.position-relative {
      position: static!important;
    }
    .not-in-list {
      position: absolute;
      right: 0;
      top: 40px;
      color: red;
    }
    .autocomplete-results {
      margin-top: 6px;
      @media (max-width: 991px) {
        margin-top: 5px;
      }
    }
  }
  .semantic-wrap {    
    .typeahead {
      .spinner-wrap {      
        left: -60px;
        .v-spinner .v-clip {
          margin-top: 5px;      
        }
      }      
    }
    button {
      display: none!important;
    }
  }  
  .search-input-wrap{
    .d-inline-block {
      vertical-align: top;
    }
    border-radius: 4px;
    //line-height: 42px;
    @media (max-width: 991px) {
      min-height: 48px;
      line-height: 48px;
    }
    li.rounded {
      background: #e3e3e3;
      font-size: 20px;
      i {
        font-size: 21px;
        color: #000;
        zoom: 0.8;
      }        
      @media (max-width: 991px) {
        font-size: 32px;
        border-radius: 4px!important;
      //  line-height: 42px;
      //  padding-bottom: 6px;
        height: 48px;
        span {
          display: inline-flex;
          line-height: 40px;
          vertical-align: top;
          i {
            margin-top: 20px;
          }
          
        } 
      }      
    }
    input#search-semantic-term {
      //font-size: 20px;
      @media (max-width: 991px) {
        font-size: 32px;        
        height: 41px;
        @media screen and (orientation:landscape) {
          max-width: 100%;
        }
      }
      width: auto!important;
      &:focus {
        outline: none;
      }
      &:disabled {
        background: #fff;
      }
    }
    .tip-dd{
      bottom: 5px;
      right: 0;
      button {
        visibility: hidden !important;
        height: 0;
        overflow: hidden;
      }
      .dropdown-menu {
        border-radius: 2px;
        padding: 0;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
        a {
          font-size: 20px;
          padding: 2px 5px;
        }
        .dropdown-item {
          &:focus {
            outline: none;
          }
        }
      }
   }
  }
}

</style>